import React, { useCallback, useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
import { useAppDispatch } from 'hooks/reduxHooks'
import { getLereLocationSeededYmalOffersWithoutRequiringMainRecommendations } from 'selectors/recommendations'
import { productClick } from 'analytics/enhanced-ecommerce'
import TrackingContext from 'contexts/trackingContext'
import Spacing from 'components/Common/Spacing'
import TrackedCardCarousel from 'components/Common/TrackedCardCarousel'
import PaneBody from 'components/Common/Pane/PaneBody'
import Pane from 'components/Common/Pane'
import Heading from 'components/Luxkit/Typography/Heading'
import { fetchDlpYmalRecommendations } from 'actions/RecommendationActions'
import { productClickObject } from 'analytics/eventDefinitions'
import uuidV4 from 'lib/string/uuidV4Utils'
import { getListName } from 'analytics/enhanced-ecommerce'
import useOffers from 'hooks/Offers/useOffers'
import StandaloneLocationSeededYmalListOffer from './StandaloneLocationSeededYmalListOffer'
import { getLereListSource } from '../common/constant'
import { ALL_GRAPH_RECOMMENDATION_OFFER_TYPES } from 'constants/recommendations'

interface OwnProps {
  destinationId: string;
  placeName: string;
}

interface Props extends OwnProps {
  analyticPageSource: string;
  currency: string;
  isLoading: boolean;
  lereVersion: string | undefined;
  offerIds: string[];
}
// This component is ALMOST the same as the LocationSeededYmalList
// Do prefer to use that when possible!!!
// Use this one if the YmalList will not be displayed on a page with a LERE-powered Offer List
function StandaloneLocationSeededYmalList(props: Props) {
  const { currency, offerIds, destinationId, placeName, lereVersion } = props
  const [offers, offersFetching] = useOffers<App.Offer>(offerIds)

  const dispatch = useAppDispatch()
  const tracking = useMemo(() => {
    const listName = getListName('LERE', props.analyticPageSource, 'Location Seeded YMAL')
    const lere = lereVersion ? { version: lereVersion } : undefined
    return ({
      label: listName,
      category: 'Recommendations',
      listId: uuidV4(),
      listName,
      lere,
    })
  }, [props.analyticPageSource, lereVersion])

  useEffect(() => {
    dispatch(fetchDlpYmalRecommendations(destinationId))
  }, [dispatch, destinationId])

  const onClick = useCallback((offer: App.Offer, position: number) => {
    productClick(currency, productClickObject(offer, position), {
      listId: tracking.listId,
      listName: tracking.listName,
      listSource: getLereListSource(tracking.lere?.version),
    })
  }, [currency, tracking])

  if (offers.length === 0 || offersFetching) {
    return null
  }

  return (
    <TrackingContext.Provider value={tracking}>
      <Pane>
        <PaneBody size="xl-y">
          <Heading variant="heading3">You may also like these deals outside {placeName.split(', ')[0]}</Heading>
          <Spacing mt={16}>
            <TrackedCardCarousel pageSize={4}>
              {offers.map((offer, index) => <StandaloneLocationSeededYmalListOffer key={offer.id} tracking={tracking} offer={offer} onClick={() => onClick(offer, index + 1)} position={index + 1}/>)}
            </TrackedCardCarousel>
          </Spacing>
        </PaneBody>
      </Pane>
    </TrackingContext.Provider>
  )
}

function mapStateToProps(state: App.State, ownProps: OwnProps) {
  const { offerIds, loadingState } = getLereLocationSeededYmalOffersWithoutRequiringMainRecommendations(state, ownProps.destinationId, ALL_GRAPH_RECOMMENDATION_OFFER_TYPES)

  return {
    currency: state.geo.currentCurrency,
    destinationId: ownProps.destinationId,
    isLoading: loadingState === 'loading',
    lereVersion: state.recommendations.lereVersion,
    offerIds,
  }
}

export default connect(mapStateToProps)(StandaloneLocationSeededYmalList)
